import { createContext, type ReactNode, useContext } from 'react';
import type { Platform } from './types';

const PlatformContext = createContext<Platform | null>(null);

/** Injects the Platform resolved once in main.tsx. */
export function PlatformProvider({ value, children }: { value: Platform; children: ReactNode }) {
  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>;
}

/** The only way a component reaches platform capabilities. */
export function usePlatform(): Platform {
  const platform = useContext(PlatformContext);
  if (!platform) throw new Error('PlatformProvider is missing');
  return platform;
}
